import React from 'react';
import {Select, SelectProps, SelectState} from 'b302-frontend-library';

import { ReactComponent as IconChevronDown } from '../../assets/icons/icon_chevron_down_pink.svg';
import { ReactComponent as IconChevronUp } from '../../assets/icons/icon_chevron_up_pink.svg';

interface Props<T, K extends keyof T> extends SelectProps<T, HTMLDivElement, K> {
    greyText?: string;
}

function HanDropdown<T, K extends keyof T>(props: Props<T, K>) {

    const renderDropdown = (state: SelectState) => {
        return (
            <React.Fragment>
                <div className="han-dropdown__title">
                    <div className="han-dropdown__text-container">
                        { state.selectedOption }

                        { props.greyText && <p className="han-dropdown__text--grey">{ props.greyText }</p> }
                    </div>

                    {state.open ? <IconChevronUp /> : <IconChevronDown />}
                </div>

                <div className={`han-dropdown__content ${state.open ? 'han-dropdown__content--open' : ''}`}>
                    { state.options }
                </div>
            </React.Fragment>
        );
    };

    return (
        <Select
            form={props.form}
            onChange={props.onChange}
            placeholder={props.placeholder}
            renderContent={renderDropdown}
            className={'han-dropdown'}
            id={props.id}
            initialIndex={props.initialIndex}>
            { props.children }
        </Select>
    );
}

export default HanDropdown;
